var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.enableTool
    ? _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _c("control-regulations", {
            attrs: {
              "data-panel": _vm.pageID,
              moduleCode: _vm.moduleCode,
              posBtnMap: _vm.mapButtons.regulations.position,
              idxBtnMap: _vm.mapButtons.regulations.order,
              showLabelBtnMap: _vm.mapButtons.regulations.showLabel,
              collapsible: _vm.mapButtons.regulations.collapsible,
              collapsed: _vm.initialCollapsedExpandCollapse,
              showButtonOnActionMap: false,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }